import React from "react";
import HindiKakkoData from "../../utils/HindiKakkoData";
import { imageUrl } from "../../utils/imageUrl";
import { ColorArray } from "../../config/ColorArray";
import SectionDivider from "../../common/SectionDivider";
import "./EkadaData.css";

const HindiKakko = () => {
    return (
        <>
        <SectionDivider title="હિન્દી કક્કો" />
        <div className="kakko-container">

            <div className="kakko-grid">
                {HindiKakkoData.map((item, index) => {
                    const textColor = ColorArray[index % ColorArray.length]?.color2;

                    return (
                        <div className="kakko-card" key={index}>

                            {/* LEFT */}
                            <div className="kakko-left">
                                <span
                                    className="kakko-letter"
                                    style={{ color: textColor }}
                                >
                                    {item.axar}
                                </span>

                                <span
                                    className="kakko-word"
                                    style={{ color: textColor }}
                                >
                                    {item.title}
                                </span>
                            </div>

                            {/* RIGHT */}
                            <div className="kakko-right">
                                <img
                                    src={imageUrl(item.image)}
                                    className="kakko-img"
                                    alt=""
                                    onError={(e) => (e.target.style.display = "none")}
                                />
                            </div>

                        </div>
                    );
                })}
            </div>

        </div>
        </>
    );
};

export default HindiKakko;
